

/**
 * Returns true if the given session is a task, false otherwise.
 *
 * @param {Object} session - The session to check.
 * @return {boolean} True if the session is a task.
 */
export function isTask(session) {
    return session?.is_task;
}